import { makeStyles } from 'tss-react/mui';
import { backgroundSwirlLight } from '../assets';
import { getColors } from '../tokens/getColors';
import { fontFamilyCorpoSText } from '../tokens/typography';

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: '100vh',
      backgroundImage: `url(${backgroundSwirlLight})`,
      backgroundSize: '100% auto',
      backgroundPosition: 'center -80px',
      backgroundRepeat: 'no-repeat',
      backgroundColor: c.background.default,
    },
    content: {
      textAlign: 'center',
      padding: '48px 24px',
    },
    title: {
      fontFamily: fontFamilyCorpoSText,
      fontSize: '2.5rem',
      fontWeight: 700,
      color: c.text.primary,
      margin: '0 0 12px',
    },
    subtitle: {
      fontFamily: fontFamilyCorpoSText,
      fontSize: '1.1rem',
      fontWeight: 400,
      color: c.text.secondary,
      margin: 0,
    },
  };
});

export interface ComingSoonPageProps {
  title?: string;
  subtitle?: string;
}

export const ComingSoonPage = ({
  title = 'Coming Soon',
  subtitle = "We're working on something new. Stay tuned.",
}: ComingSoonPageProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <h1 className={classes.title}>{title}</h1>
        <p className={classes.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};
